import { httpsCallable } from 'firebase/functions';

/** Misma allowlist que `functions/index.js` (solo UI; el borrado valida claim en servidor). */
const MLV_ADMIN_EMAIL_ALLOWLIST = Object.freeze(['kevinmaggio57@gmail.com']);

function esEmailAdminVerificado(user) {
  if (!user?.emailVerified) return false;
  const e = String(user.email || '')
    .trim()
    .toLowerCase();
  return MLV_ADMIN_EMAIL_ALLOWLIST.includes(e);
}

/**
 * ¿Mostrar controles de moderación admin en el cliente?
 * Refresca token / intenta asignar claim; si falla, fallback por email verificado en allowlist.
 */
export async function resolverEsAdminSesion(getFirebase) {
  const user = getFirebase()?.auth?.currentUser;
  if (!user) return false;

  const tieneClaim = (tr) => tr?.claims?.admin === true;

  try {
    let tr = await user.getIdTokenResult();
    if (tieneClaim(tr)) return true;

    await user.getIdToken(true);
    tr = await user.getIdTokenResult();
    if (tieneClaim(tr)) return true;

    const { fns } = getFirebase();
    if (fns) {
      try {
        const call = httpsCallable(fns, 'verificarAdminClaim');
        const res = await call({});
        if (res?.data?.granted === true) {
          await user.getIdToken(true);
          tr = await user.getIdTokenResult();
          if (tieneClaim(tr)) return true;
        }
      } catch (_e) {
        /* Functions caídas o sin deploy */
      }
    }

    tr = await user.getIdTokenResult();
    if (tieneClaim(tr)) return true;
  } catch (_e) {
    /* sigue al fallback email */
  }

  return esEmailAdminVerificado(user);
}

/** Revalidación estricta antes de llamar a Functions (solo claim, sin email). */
export async function revalidarClaimAdminParaAccion(user) {
  if (!user) return false;
  try {
    await user.getIdToken(true);
    const tr = await user.getIdTokenResult();
    return tr?.claims?.admin === true;
  } catch (_e) {
    return false;
  }
}

/** Intenta obtener claim admin antes de una acción sensible (p. ej. borrar publicación). */
export async function asegurarClaimAdminParaAccion(getFirebase) {
  const user = getFirebase()?.auth?.currentUser;
  if (!user) return false;
  if (await revalidarClaimAdminParaAccion(user)) return true;
  if (!esEmailAdminVerificado(user)) return false;
  const { fns } = getFirebase();
  if (!fns) return false;
  try {
    const call = httpsCallable(fns, 'verificarAdminClaim');
    await call({});
    await user.getIdToken(true);
    return revalidarClaimAdminParaAccion(user);
  } catch (_e) {
    return false;
  }
}
